/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import styled from "styled-components";
import { Button, Tooltip } from "@nordcloud/gnui";

export const TooltipWrap = styled.div`
  position: relative;
`;

type UnassignButtonProps = {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

function UnassignButton({ setIsOpen }: UnassignButtonProps) {
  return (
    <TooltipWrap>
      <Tooltip status="notification" caption="Unassign Tool" hideTimeout={0}>
        <Button
          onClick={() => setIsOpen(true)}
          type="button"
          css={{ marginLeft: "auto" }}
          size="sm"
          severity="medium"
          icon="brokenLink"
        />
      </Tooltip>
    </TooltipWrap>
  );
}

export { UnassignButton };
